import { composeFetch } from '@library/http'
import {
  addPath,
  composeRequest,
  goustoHeaders,
  setMethod,
  setQueryParams,
  setServiceUrl,
} from '@library/http/requests'

import type { BasketInput, BasketResponse } from './interfaces/basket'

const getBasketResponseParser = async (response: Response): Promise<BasketResponse> => {
  if (!response.ok) {
    const responseMsg = await response.text()
    throw new Error(`service responded with ${response.status}: ${responseMsg}`)
  }

  return response.json()
}

export const basketFetcher = composeFetch(
  composeRequest<BasketInput>(
    setServiceUrl('menuexperience', 1),
    addPath('basket'),
    goustoHeaders,
    setMethod('GET'),
    setQueryParams(
      ({
        menuId,
        menuUrn,
        numPortions,
        deliveryDate,
        postcode,
        deliverySlotId,
        shippingAddressId,
        orderId,
        products,
        recipes,
      }) => ({
        ...(menuUrn !== undefined ? { menuUrn } : menuId && { menuId }),
        numPortions: numPortions.toString(),
        deliveryDate,
        ...(postcode ? { postcode } : {}),
        recipes: JSON.stringify(recipes),
        ...(deliverySlotId ? { deliverySlotId } : {}),
        ...(shippingAddressId ? { shippingAddressId } : {}),
        ...(orderId ? { orderId } : {}),
        ...(products ? { products: JSON.stringify(products) } : {}),
      }),
    ),
  ),
  getBasketResponseParser,
)
